import type { PrimaryCountryISOElseGlobal } from '@/constants/countries';
import type { SortBy } from '../hooks/useSortByOptions';
import { getPath } from '@/router/utils';
import {
  ROUTE_STOCKS_MARKET,
  ROUTE_STOCKS_MARKET_INDUSTRY,
} from '@/constants/routes';
import { DEFAULT_INDUSTRY } from '../constants';

interface PathRequest {
  type: typeof ROUTE_STOCKS_MARKET | typeof ROUTE_STOCKS_MARKET_INDUSTRY;
  payload: {
    market: PrimaryCountryISOElseGlobal;
    industry?: string | 'any';
    sortBy?: SortBy;
    query?: {
      page: string;
    };
  };
}

interface PathPayload {
  market: PrimaryCountryISOElseGlobal;
  excludePageQuery: boolean;
  industry?: string;
  sortBy?: SortBy;
}

export const getStocksRouterAction = ({
  excludePageQuery,
  market,
  industry,
  sortBy,
}: PathPayload) => {
  const pathRequest: PathRequest = {
    payload: {
      market: market as PrimaryCountryISOElseGlobal,
      sortBy,
      query: excludePageQuery ? undefined : { page: '1' },
    },
    type: ROUTE_STOCKS_MARKET,
  };
  if (typeof industry !== 'undefined' && industry !== DEFAULT_INDUSTRY) {
    pathRequest.payload.industry = industry;
    pathRequest.type = ROUTE_STOCKS_MARKET_INDUSTRY;
  }
  return pathRequest;
};

export const getStocksPath = ({
  excludePageQuery,
  market,
  industry,
  sortBy,
}: PathPayload) => {
  try {
    return getPath(
      getStocksRouterAction({
        excludePageQuery,
        market,
        industry,
        sortBy,
      })
    );
  } catch (e) {
    console.warn(e);
  }
};
